export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("property-management-common/lang/en.lyaml"));
at({ "en": { "placeholder": "Placeholder" } });
};